<template>
  <div class="pc-explorationDetail">
    <!-- 头部面包屑以及文字，和编辑功能 -->
    <div class="pc-explorationDetail-head">
      <div class="pc-explorationDetail-head-bread">
        <h2>前沿管理</h2>
        <BreadCrumb
          :data="breadcrumb"
          class="pc-explorationDetail-breadcrumb"
        />
      </div>
      <h4 v-show="editExploration == false" @click="edit">编辑</h4>
      <h4
        v-show="editExploration == true && bpType == 'update'"
        @click="
          edit();
          saveArea();
        "
      >
        完成
      </h4>
      <h4
        v-show="editExploration == true && bpType == 'add'"
        @click="
          edit();
          addExploration();
        "
      >
        新增
      </h4>
    </div>
    <!-- 大学详情页基本信息 -->
    <div
      v-show="editExploration == false"
      class="pc-explorationDetail-information">
      <h2>前沿基本信息</h2>
      <div class="pc-explorationDetail-information-contain">
        <!-- 左边边图片 -->
        <div class="pc-explorationDetail-information-contain-img contain-img">
          <div v-if="explorationDetail.bgSmallImage != null" class="logo-Img">
            <img :src="explorationDetail.bgSmallImage" />
          </div>
          <div v-if="explorationDetail.bgImage != null" class="logo-Img">
            <img :src="explorationDetail.bgImage" />
          </div>
        </div>
        <!-- 右边文字内容 -->
        <ul class="pc-explorationDetail-information-contain-word">
          <li>
            <h4>标题：</h4>
            <span>{{ explorationDetail.name }}</span>
          </li>
          <li>
            <h4>英文标题：</h4>
            <span>{{ explorationDetail.englishName }}</span>
          </li>
          <li>
            <h4>创建日期：</h4>
            <span v-if="explorationDetail.createTime">
              {{ $dtime(explorationDetail.createTime).format("YYYY-MM-DD") }}
            </span>
            <span v-if="!explorationDetail.createTime">暂无</span>
          </li>
          <li>
            <h4>更新日期：</h4>
            <span v-if="explorationDetail.updateTime">
              {{ $dtime(explorationDetail.updateTime).format("YYYY-MM-DD") }}
            </span>
            <span v-if="!explorationDetail.updateTime">暂无</span>
          </li>
          <li>
            <h4>状态：</h4>
            <span v-if="explorationDetail.status == 0">失效</span>
            <span v-if="explorationDetail.status == 1">有效</span>
          </li>
        </ul>
      </div>
    </div>
    <!-- 修改大学详情基本信息页 -->
    <div
      v-show="editExploration == true"
      class="pc-explorationDetail-information">
      <h2>前沿基本信息</h2>
      <div class="pc-explorationDetail-information-contain">
        <!-- 左边边图片 -->
        <div class="pc-explorationDetail-information-contain-img">
          <el-upload
            v-if="percentageFile==0"
            class="logoImg"
            :action="uploadUrl"
            list-type="picture-card"
            accept=".png,.PNG,.jpg,.JPG,.jpeg"
            :http-request="uploadSmallFile"
            :show-file-list="false"
            :auto-upload="true"
          >
            <img
              v-if="explorationDetail.bgSmallImage"
              :src="explorationDetail.bgSmallImage"
              class="upload-image"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div class="process" v-if="percentageFile!=0">
            <el-progress
              type="circle"
              :width = 100
              :percentage="this.percentageFile"
            ></el-progress>
          </div>
          <!-- <el-input v-model="explorationDetail.bgSmallImage"></el-input> -->
        </div>
        <div class="pc-explorationDetail-information-contain-img">
          <el-upload
            v-if="percentageLogo==0"
            class="logoImg"
            :action="uploadUrl"
            list-type="picture-card"
            accept=".png,.PNG,.jpg,.JPG,.jpeg"
            :http-request="uploadLogoFile"
            :show-file-list="false"
            :auto-upload="true"
          >
            <img
              v-if="explorationDetail.bgImage"
              :src="explorationDetail.bgImage"
              class="upload-image"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div class="process" v-if="percentageLogo!=0">
            <el-progress
              type="circle"
              :width = 100
              :percentage="this.percentageLogo"
            ></el-progress>
          </div>
          <!-- <el-input v-model="explorationDetail.bgImage"></el-input> -->
        </div>

        <!-- 右边文字内容 -->
        <ul class="pc-explorationDetail-information-contain-word">
          <li>
            <h4>标题：</h4>
            <el-input
              v-model="explorationDetail.name"
              placeholder="请输入中文标题"
            ></el-input>
          </li>
          <li>
            <h4>英文标题：</h4>
            <el-input
              v-model="explorationDetail.englishName"
              placeholder="请输入英文标题"
            ></el-input>
          </li>
          <li>
            <h4>创建日期：</h4>
            <el-date-picker
              v-model="explorationDetail.createTime"
              type="date"
              placeholder="选择日期"
            >
            </el-date-picker>
          </li>
          <li>
            <h4>更新日期：</h4>
            <el-date-picker
              v-model="explorationDetail.updateTime"
              type="date"
              placeholder="选择日期"
            >
            </el-date-picker>
          </li>
          <li>
            <h4>状态：</h4>
            <el-switch
              v-model="explorationDetail.status"
              active-color="#91CC75"
              inactive-color="#ff4949"
              :active-value="1"
              :inactive-value="0"
              style="align-self: center"
            >
            </el-switch>
          </li>
        </ul>
      </div>
    </div>
    <!-- 作者信息 -->
    <div class="pc-explorationDetail-article">
      <h2>作者信息</h2>
      <!-- exploration默认展示的样式 -->
      <div
        class="pc-explorationDetail-article-contain"
        v-if="editExploration == false"
      >
        <div class="pc-explorationDetail-article-logo">
          <div v-if="explorationDetail.authorImage != null" class="logo-Img">
            <img :src="explorationDetail.authorImage" />
          </div>
        </div>
        <ul>
          <li>
            <h4>姓名：</h4>
            <span>{{ explorationDetail.author }}</span>
          </li>
          <li>
            <h4>英文姓名：</h4>
            <span>{{ explorationDetail.authorEnglishName }}</span>
          </li>
          <li>
            <h4>职称：</h4>
            <span v-if="explorationDetail.authorTitle">
              {{ explorationDetail.authorTitle }}
            </span>
            <span v-if="!explorationDetail.authorTitle">暂无</span>
          </li>
          <li>
            <h4>院校：</h4>
            <span v-if="explorationDetail.authorUniversity">
              {{ explorationDetail.authorUniversity }}
            </span>
            <span v-if="!explorationDetail.authorUniversity">暂无</span>
          </li>
        </ul>
      </div>
      <!-- exploration点击编辑后的样式 -->
      <div
        class="pc-explorationDetail-article-contain"
        v-if="editExploration == true"
      >
        <div class="pc-explorationDetail-article-logo">
          <el-upload
            v-if="percentageArticle==0"
            class="logoImg"
            :action="uploadUrl"
            list-type="picture-card"
            accept=".png,.PNG,.jpg,.JPG,.jpeg"
            :http-request="uploadArticle"
            :show-file-list="false"
            :auto-upload="true"
          >
            <img
              v-if="explorationDetail.authorImage"
              :src="explorationDetail.authorImage"
              class="upload-image"
              style="width: 350px;height: 250px;"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div class="process" v-if="percentageArticle!=0">
            <el-progress
              type="circle"
              :width = 100
              :percentage="this.percentageArticle"
            ></el-progress>
          </div>
          <!-- <el-input v-model="explorationDetail.authorImage"></el-input> -->
        </div>
        <ul>
          <li>
            <h4>姓名：</h4>
            <el-input
              v-model="explorationDetail.author"
              placeholder="请输入中文姓名"
            ></el-input>
          </li>
          <li>
            <h4>英文姓名：</h4>
            <el-input
              v-model="explorationDetail.authorEnglishName"
              placeholder="请输入英文姓名"
            ></el-input>
          </li>
          <li>
            <h4>职称：</h4>
            <el-input
              v-model="explorationDetail.authorTitle"
              placeholder="请输入职称英文"
            ></el-input>
          </li>
          <li>
            <h4>院校：</h4>
            <el-input
              v-model="explorationDetail.authorUniversity"
              placeholder="请输入院校英文名称"
            ></el-input>
          </li>
        </ul>
      </div>
    </div>
    <!-- 大学详情页院校标签 -->
    <TagDetail
      :dataDetail="explorationDetail"
      :managerState="managerState"
      :filterArr="filterArr"
      @updateTag="updateTag"
    />
    <!-- 院校详情 -->
    <div class="pc-explorationDetail-detail" v-show="bpType == 'update'">
      <el-tabs v-model="dialogMsg.activeName" @tab-click="handleClick">
        <el-tab-pane label="关键词" class="tabs-keywords" name="keywords">
          <!-- 点击编辑前的样式 -->
          <div v-show="editExploration == false" class="tabs-keywords-contain">
            <dl v-for="(item, index) in tagPage.keywords" :key="index">
              <dd>关键字{{ index + 1 }}</dd>
              <dt>
                <span>{{ item.name }}</span>
                <span>{{ item.englishName }}</span>
              </dt>
            </dl>
          </div>
          <!-- 点击编辑后的样式 -->
          <div v-show="managerState" class="tabs-keywords-contain">
            <dl v-for="(item, index) in tagPage.keywords" :key="index"
            :class="managerState ? 'choice-keywords' : ''"
            >
              <dd>关键字{{ index + 1 }}</dd>
              <dt>
                <el-input
                  v-model="item.name"
                  class="keywordsInput"
                  placeholder="请输入关键词"
                ></el-input>
                <el-input
                  class="keywordsInput"
                  v-model="item.englishName"
                  placeholder="请输入关键词英文"
                ></el-input>
              </dt>
              <i
                @click="deleteKeyWorlds(item.id,item)"
                v-show="managerState"
                class="el-icon-error"
              ></i>
            </dl>
          </div>
          <div
            @click="addKeyWords"
            v-show="managerState"
            class="add-keywords addTitle"
          >
            <i class="el-icon-circle-plus-outline"></i>
            <span>&nbsp;添加关键字</span>
          </div>
        </el-tab-pane>
        <el-tab-pane label="学者" class="tabs-scholars" name="scholars">
          <div class="tabs-scholars-contain">
            <!-- @click="updateScholar(item)" -->
            <dl
              v-for="(item, index) in tagPage.scholars"
              :key="index"
              :class="managerState ? 'choice-scholar' : ''"
            >
              <dd>
                <img :src="item.image" />
              </dd>
              <dt>
                <h4>{{ item.name }}</h4>
                <span>{{ item.englishName }}</span>
              </dt>
              <i
                v-show="managerState"
                @click="deleteScholar(item.id)"
                class="el-icon-close"
              />
            </dl>
          </div>

          <div
            @click="addScholars"
            v-show="managerState"
            class="add-keywords addTitle"
          >
            <i class="el-icon-circle-plus-outline"></i>
            <span>&nbsp;添加学者</span>
          </div>
        </el-tab-pane>
        <el-tab-pane label="书籍" class="tabs-books" name="books">
          <div class="tabs-books-contain">
            <dl
              v-for="(item, index) in tagPage.books"
              :class="managerState ? 'choice-book' : ''"
              :key="index"
            >
              <dd>
                <img :src="item.image" />
              </dd>
              <dt>
                <div>
                  <h5>{{ item.name }}</h5>
                  <h5>{{ item.englishName }}</h5>
                  <h6>
                    {{ item.author }} &nbsp;&nbsp;&nbsp;&nbsp;
                    {{
                      $dtime(item.publishTime).format("YYYY-MM-DD")
                    }}&nbsp;&nbsp;&nbsp;&nbsp;{{ item.organizer }}
                  </h6>
                </div>
                <span>{{ item.recommendReason }}</span>
              </dt>
              <i
                @click="updateBooksMag(item)"
                v-show="managerState"
                class="el-icon-edit"
              ></i>
              <i
                @click="deletePaper(item.id)"
                v-show="managerState"
                class="el-icon-error"
              ></i>
            </dl>
          </div>
          <div
            @click="addBooksMagazine"
            v-show="managerState"
            class="add-keywords addTitle"
          >
            <i class="el-icon-circle-plus-outline"></i>
            <span>&nbsp;添加书籍</span>
          </div>
        </el-tab-pane>
        <el-tab-pane
          label="杂志"
          class="tabs-magazines tabs-books"
          name="magazines"
        >
          <div class="tabs-books-contain">
            <dl
              v-for="(item, index) in tagPage.magazines"
              :class="managerState ? 'choice-book' : ''"
              :key="index"
            >
              <dd>
                <img :src="item.image" />
              </dd>
              <dt>
                <div>
                  <h5>{{ item.name }}</h5>
                  <h5>{{ item.englishName }}</h5>
                  <h6>
                    {{ item.author }}&nbsp;&nbsp;&nbsp;&nbsp;{{
                      item.organizer
                    }}
                  </h6>
                </div>
                <span>{{ item.recommendReason }}</span>
              </dt>
              <i
                @click="updateBooksMag(item)"
                v-show="managerState"
                class="el-icon-edit"
              ></i>
              <i
                @click="deletePaper(item.id)"
                v-show="managerState"
                class="el-icon-error"
              ></i>
            </dl>
          </div>
          <div
            @click="addBooksMagazine"
            v-show="managerState"
            class="add-keywords addTitle"
          >
            <i class="el-icon-circle-plus-outline"></i>
            <span>&nbsp;添加杂志</span>
          </div>
        </el-tab-pane>
        <el-tab-pane label="文章" class="tabs-articles" name="articles">
          <div class="tabs-articles-contain">
            <dl
              v-for="(item, index) in tagPage.articles"
              :class="managerState ? 'choice-articles' : ''"
              :key="index"
            >
              <dd>
                <i class="el-icon-document"></i>
              </dd>
              <dt>
                <div>
                  <h5>{{ item.name }}</h5>

                  <h6>
                    {{ item.author }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{
                      item.organizer
                    }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ item.orderNum }}
                  </h6>
                </div>
                <span>{{ item.intro }}</span>
                <span>{{ item.recommendReason }}</span>
              </dt>
              <i
                @click="updateArtice(item)"
                v-show="managerState"
                class="el-icon-edit"
              ></i>
              <i
                @click="deletePaper(item.id)"
                v-show="managerState"
                class="el-icon-error"
              ></i>
            </dl>
          </div>
          <div
            @click="addArtice"
            v-show="managerState"
            class="add-keywords addTitle"
          >
            <i class="el-icon-circle-plus-outline"></i>
            <span>&nbsp;添加文章</span>
          </div>
        </el-tab-pane>
        <el-tab-pane label="案例" class="tabs-cases" name="cases">
          <div class="tabs-cases-contain">
            <dl
              v-for="(item, index) in tagPage.cases"
              :key="index"
              :class="managerState ? 'choice-cases' : ''"
            >
              <dd v-if="item.image">
                <img  :src="item.image" />
              </dd>
              <dt>
                <h4>{{ item.name }}</h4>
                <span>{{ item.author }}</span>
              </dt>
              <i
                @click="updateCase(item)"
                v-show="managerState"
                class="el-icon-edit"
              ></i>
              <i
                @click="deletePaper(item.id)"
                v-show="managerState"
                class="el-icon-error"
              ></i>
            </dl>
          </div>

          <div
            @click="addCase"
            v-show="managerState"
            class="add-cases addTitle"
          >
            <i class="el-icon-circle-plus-outline"></i>
            <span>&nbsp;添加案列</span>
          </div>
        </el-tab-pane>
        <el-tab-pane label="会议" class="tabs-conferences" name="conferences">
          <div class="tabs-conferences-contain">
            <dl
              v-for="(item, index) in tagPage.conferences"
              :key="index"
              :class="managerState ? 'choice-conferences' : ''"
            >
              <dd>
                <img v-if="item.image" :src="item.image" />
              </dd>
              <dt>
                <h4>{{ item.name }}</h4>
                <span>{{ item.englishName }}</span>
              </dt>
              <i
                @click="updatePaper(item)"
                v-show="managerState"
                class="el-icon-edit"
              ></i>
              <i
                @click="deletePaper(item.id)"
                v-show="managerState"
                class="el-icon-error"
              ></i>
            </dl>
          </div>

          <div
            @click="addTabs"
            v-show="managerState"
            class="add-conferences addTitle"
          >
            <i class="el-icon-circle-plus-outline"></i>
            <span>&nbsp;添加会议</span>
          </div>
        </el-tab-pane>
        <el-tab-pane
          label="组织"
          class="tabs-organizations tabs-conferences"
          name="organizations"
        >
          <div class="tabs-organizations-contain tabs-conferences-contain">
            <dl
              v-for="(item, index) in tagPage.organizations"
              :key="index"
              :class="managerState ? 'choice-conferences' : ''"
            >
              <dd>
                <img v-if="item.image" :src="item.image" />
              </dd>
              <dt>
                <h4>{{ item.name }}</h4>
                <span>{{ item.englishName }}</span>
              </dt>
              <i
                @click="updatePaper(item)"
                v-show="managerState"
                class="el-icon-edit"
              ></i>
              <i
                @click="deletePaper(item.id)"
                v-show="managerState"
                class="el-icon-error"
              ></i>
            </dl>
          </div>

          <div
            @click="addTabs"
            v-show="managerState"
            class="add-organizations add-conferences addTitle"
          >
            <i class="el-icon-circle-plus-outline"></i>
            <span>&nbsp;添加组织</span>
          </div>
        </el-tab-pane>
        <el-tab-pane
          label="机构"
          class="tabs-institutions tabs-conferences"
          name="institutions"
        >
          <div class="tabs-institutions-contain tabs-conferences-contain">
            <dl
              v-for="(item, index) in tagPage.institutions"
              :key="index"
              :class="managerState ? 'choice-conferences' : ''"
            >
              <dd>
                <img v-if="item.image" :src="item.image" />
              </dd>
              <dt>
                <h4>{{ item.name }}</h4>
                <span>{{ item.englishName }}</span>
              </dt>
              <i
                @click="updatePaper(item)"
                v-show="managerState"
                class="el-icon-edit"
              ></i>
              <i
                @click="deletePaper(item.id)"
                v-show="managerState"
                class="el-icon-error"
              ></i>
            </dl>
          </div>

          <div
            @click="addTabs"
            v-show="managerState"
            class="add-institutions add-conferences addTitle"
          >
            <i class="el-icon-circle-plus-outline"></i>
            <span>&nbsp;添加机构</span>
          </div>
        </el-tab-pane>
        <el-tab-pane
          label="网站"
          class="tabs-websites tabs-conferences"
          name="websites"
        >
          <div class="tabs-websites-contain tabs-conferences-contain">
            <dl
              v-for="(item, index) in tagPage.websites"
              :key="index"
              :class="managerState ? 'choice-conferences' : ''"
            >
              <dd>
                <img v-if="item.image" :src="item.image" />
              </dd>
              <dt>
                <h4>{{ item.name }}</h4>
                <span>{{ item.englishName }}</span>
              </dt>
              <i
                @click="updatePaper(item)"
                v-show="managerState"
                class="el-icon-edit"
              ></i>
              <i
                @click="deletePaper(item.id)"
                v-show="managerState"
                class="el-icon-error"
              ></i>
            </dl>
          </div>

          <div
            @click="addTabs"
            v-show="managerState"
            class="add-websites add-conferences addTitle"
          >
            <i class="el-icon-circle-plus-outline"></i>
            <span>&nbsp;添加网站</span>
          </div>
        </el-tab-pane>
      </el-tabs>
      <!-- <div @click="testEng" v-show="editExploration == true">中--英</div> -->
    </div>
    <DialogKeyWorlds
      :dialogMsg="dialogMsg"
      @addKeyBack="addKeyBack"
      @addKeyOK="addKeyOK"
    />
    <DialogScholar
      :dialogMsg="dialogMsg"
      :dialogItem="dialogItem"
      @addScholarBack="addScholarBack"
      @addScholarOK="addScholarOK"
    />
    <DialogBooksMagazines
      :dialogMsg="dialogMsg"
      :dialogItem="dialogItem"
      @addBack="addBack"
      @addOK="addOK"
    />
    <DialogArticles
      :dialogMsg="dialogMsg"
      :dialogItem="dialogItem"
      @addArticleOK="addArticleOK"
      @addArticleBack="addArticleBack"
    />
    <DialogCase
      :dialogMsg="dialogMsg"
      :dialogItem="dialogItem"
      @addCaseBack="addCaseBack"
      @addCaseOK="addCaseOK"
      ref="caseRef"
    />
    <DialogTabs
      :dialogMsg="dialogMsg"
      :dialogItem="dialogItem"
      @addTabsBack="addTabsBack"
      @addTabsOK="addTabsOK"
    />
    <DialogDelete
      :dialogDeleteMsg="dialogDeleteMsg"
      @tabsCancel="tabsCancel"
      @tabsScholarDelete="tabsScholarDelete"
      @ispaperDelete="ispaperDelete"
      @tabsKeyWoldsDelete="tabsKeyWoldsDelete"
    />
    <DeleteDialog
      @isDelete="isDelete"
      @isCancel="isCancel"
      :dialogVisible="deleteShow"
      :delid="deleteId"
    />
    <div class="pc-exploration-button" v-show="editExploration == true">
      <h4
        @click="edit(); getExploration()"
        v-show="bpType == 'update'"
      >
        恢复
      </h4>
      <h4 @click="edit();
          saveArea()">保存</h4>
    </div>
  </div>
</template>
<script>
// 功能模板
import DeleteDialog from "../../template/DeleteDialog";
import BreadCrumb from "../../template/BreadCrumb";
import TagDetail from "../../template/TagDetail";
import DialogBooksMagazines from "./components/DialogBooksMagazines";
import DialogKeyWorlds from "./components/DialogKeyWorlds";
import DialogScholar from "./components/DialogScholar";
import DialogArticles from "./components/DialogArticles";
import DialogCase from "./components/DialogCase";
import DialogTabs from "./components/DialogTabs";
// 私有删除组件
import DialogDelete from "./components/DialogDelete";
// 接口引入
import {
  getExploration,
  updateExploration,
  addExploration,
  addExplorationPaper,
  addExplorationPerson,
  getPersons,
  getPersonsDetai,
  getExplorationPapers
} from "./explorationList.gql";
import {
  deleteExplorationPersons,
  deleteExplorationPapers,
  updateExplorationPaper
} from "./explorationTabs.gql";
export default {
  components: {
    BreadCrumb,
    DeleteDialog,
    TagDetail,
    DialogBooksMagazines,
    DialogKeyWorlds,
    DialogScholar,
    DialogDelete,
    DialogArticles,
    DialogCase,
    DialogTabs
  },
  computed: {
    breadcrumb: function() {
      return [
        { name: "前沿管理", link: this.$route.path+'?id='+this.$router.app._route.query.id },
        { name: "前沿列表", link: "/admin/explorationlist" },
        {
          name: this.breadName ? this.breadName : null,
          link: ""
        }
      ];
    }
  },
  data() {
    return {
      // 上传图片初始URL
      bpType: "",
      uploadUrl: "",
      percentageLogo:0,
      percentageFile:0,
      percentageArticle:0,
      explorationDetail: {
        keywords: [],
        tags: [],
        id: "",
        msgTitle: "前沿",
        type: "Exploration"
      },
      tagPage: {
        keywords: [],
        scholars: [],
        books: [],
        magazines: [],
        articles: [],
        cases: [],
        conferences: [],
        organizations: [],
        institutions: [],
        websites: []
      },
      // 判断当前是否需要编辑
      editExploration: false,
      // 面包屑名字
      breadName: "",
      // manager 编辑按钮
      managerState: false,
      // 删除弹框的显示隐藏
      deleteShow: false,
      // 杂志 书籍的显示隐藏
      dialogMsg: {
        dialogBookMagaz: false,
        // 关键字的弹框
        dialogKeyWorlds: false,
        // 学者的弹框
        dialogScholar: false,
        // 文章的弹框
        dialogArticle: false,
        // 案列的弹框
        dialogCase: false,
        // 其他的弹框
        dialogTab: false,
        // 功能面板当前显示的页面
        activeName: "keywords",
        item: {}
      },
      dialogItem: {},
      // 删除面板的Id
      deleteId: "-1",
      // 删除页面
      dialogDeleteMsg: {
        dialogDelete: false,
        id: "",
        data: { ids: [] },
        title: ""
      },
      // 过滤标签数组
      filterArr:[],
    };
  },
  created() {},
  mounted() {
    if (this.$router.app._route.query.id == null) {
      this.bpType = "add";
      this.edit();
    } else {
      this.bpType = "update";
      this.getExploration();
      
    }
    // this.edit();

    // 查询相应人物
  },
  methods: {
    handleClick(tab) {
      this.getExplorationPapers();
    },
    getExplorationPapers() {
      this.$global
        .GraphqlQuery(this, getExplorationPapers, {
          type: this.dialogMsg.activeName,
          keywords: this.explorationDetail.name,
          order: "-createTime"
        })
        .then(res => {
          if (this.dialogMsg.activeName == "books") {
            this.tagPage.books = res.data;
          }
          if (this.dialogMsg.activeName == "magazines") {
            this.tagPage.magazines = res.data;
          }
          if (this.dialogMsg.activeName == "articles") {
            this.tagPage.articles = res.data;
          }
          if (this.dialogMsg.activeName == "cases") {
            this.tagPage.cases = res.data;
          }
          if (this.dialogMsg.activeName == "conferences") {
            this.tagPage.conferences = res.data;
          }
          if (this.dialogMsg.activeName == "organizations") {
            this.tagPage.organizations = res.data;
          }
          if (this.dialogMsg.activeName == "institutions") {
            this.tagPage.institutions = res.data;
          }
          if (this.dialogMsg.activeName == "websites") {
            this.tagPage.websites = res.data;
          }
        });
    },
    getExploration() {
      this.$global
        .GraphqlQuery(this, getExploration, {
          id: this.$router.app._route.query.id
        })
        .then(res => {
          this.tagPage.keywords = res.data[0].keywords;
          this.explorationDetail = res.data[0];
          this.explorationDetail.msgTitle = "前沿";
          this.breadName = this.explorationDetail.name;
          this.getScholar(res.data[0].name);
          this.findFilterArr()
        });
    },
        // 存储标签需要过滤的数组
    findFilterArr(){
       this.filterArr = []
      if(this.explorationDetail.award){
        
        this.explorationDetail.award.name && this.filterArr.push(this.explorationDetail.award.name)
        this.explorationDetail.award.type && this.filterArr.push(this.explorationDetail.award.type)
        this.explorationDetail.award.englishName && this.filterArr.push(this.explorationDetail.award.englishName)
      }
        this.explorationDetail.author && this.filterArr.push(this.explorationDetail.author)
        this.explorationDetail.authorEnglishName && this.filterArr.push(this.explorationDetail.authorEnglishName)
    },
    // 获取学者数据
    getScholar(name) {
      this.$global
        .GraphqlQuery(this, getPersons, {
          keywords: name
        })
        .then(res => {
          this.tagPage.scholars = res.data;
        });
    },
    // 上传头像
    async uploadLogoFile(params) {
      // this.$global.uploadImage(this, params).then(res => {
      //   this.explorationDetail.bgImage = res.split("?")[0];
      // });
      let config = {
        onUploadProgress: (progressEvent) => {
          process =
            (progressEvent.loaded / progressEvent.total).toFixed(2) * 100;
          this.percentageLogo = parseInt(process);
        },
      };
      this.$global.uploadImageWithConfig(this, params, config).then((res) => {
        this.explorationDetail.bgImage = res.url.split("?")[0];
        this.percentageLogo=0
      });
    },
    // 上传头像
    async uploadSmallFile(params) {
      // this.$global.uploadImage(this, params).then(res => {
      //   this.explorationDetail.bgSmallImage = res.split("?")[0];
      // });
      console.dir(params.file.name);
      let config = {
        onUploadProgress: (progressEvent) => {
          process =
            (progressEvent.loaded / progressEvent.total).toFixed(2) * 100;
          this.percentageFile = parseInt(process);
        },
      };
      this.$global.uploadImageWithConfig(this, params, config).then((res) => {
        this.explorationDetail.bgSmallImage = res.url.split("?")[0];
        this.percentageFile=0
      });
    },
    //  院校图片
    uploadArticle(params) {
      // this.$global.uploadImage(this, params).then(res => {
      //   // this.explorationDetail.logo = res.split('?')[0]
      //   // this.explorationDetail.pictures.push({ image: res.split("?")[0] });
      //   this.explorationDetail.authorImage = res.split("?")[0];
      // });
      console.dir(params.file.name);
      let config = {
        onUploadProgress: (progressEvent) => {
          process =
            (progressEvent.loaded / progressEvent.total).toFixed(2) * 100;
          this.percentageArticle = parseInt(process);
        },
      };
      this.$global.uploadImageWithConfig(this, params, config).then((res) => {
        this.explorationDetail.authorImage = res.url.split("?")[0];
        this.percentageArticle=0
      });
    },
    // 子传父
    updateTag(tags) {
      this.explorationDetail.tags = tags
    },
    // 添加大分类
    addKeyWords() {
      this.dialogMsg.kind = "";
      this.dialogMsg.dialogKeyWorlds = true;
    },
    //打开 添加学者的弹框
    addScholars() {
      this.dialogMsg.kind = "";
      this.dialogMsg.dialogScholar = true;
    },
    // 打开 书籍或者杂志的弹框
    addBooksMagazine(name) {
      this.dialogMsg.kind = "";
      this.dialogMsg.dialogBookMagaz = true;
    },
    addArtice() {
      this.dialogMsg.kind = "";
      this.dialogMsg.dialogArticle = true;
    },
    addCase() {
      this.dialogMsg.kind = "";
      this.dialogMsg.dialogCase = true;
      // this.$refs.caseRef.
    },
    addTabs() {
      this.dialogMsg.kind = "";
      this.dialogMsg.dialogTab = true;
    },
    addBack() {
      this.dialogMsg.kind = "";
      this.dialogMsg.dialogBookMagaz = false;
      this.getExplorationPapers();
    },
    addKeyBack() {
      this.dialogMsg.kind = "";
      this.dialogMsg.dialogKeyWorlds = false;
      this.getExplorationPapers();
    },
    addScholarBack() {
      this.dialogMsg.kind = "";
      this.dialogMsg.dialogScholar = false;
      this.getExplorationPapers();
    },
    addArticleBack() {
      this.dialogMsg.kind = "";
      this.dialogMsg.dialogArticle = false;
      this.getExplorationPapers();
    },
    addCaseBack() {
      this.dialogMsg.kind = "";
      this.dialogMsg.dialogCase = false;
      this.getExplorationPapers();
    },
    addTabsBack() {
      this.dialogMsg.kind = "";
      this.dialogMsg.dialogTab = false;
      this.getExplorationPapers();
    },
    addOK(addMsg) {
      addMsg.explorationId = this.$router.app._route.query.id;
      let {
        name,
        englishName,
        author,
        publishTime,
        organizer,
        source,
        recommendReason,
        image,
        explorationId,
        tags
      } = addMsg;
      const subEntity = {
        name,
        englishName,
        author,
        publishTime,
        organizer,
        source,
        explorationId,
        recommendReason,
        image,
        tags
      };

      if (this.dialogMsg.activeName == "books") {
        subEntity.type = "books";
        if (this.dialogMsg.kind == "update") {
          this.$global
            .GraphqlMutation(this, updateExplorationPaper, {
              data: subEntity,
              id: addMsg.id
            })
            .then(res => {
              this.dialogMsg.dialogBookMagaz = false;
              this.getExplorationPapers();
            });
        } else {
          this.$global
            .GraphqlMutation(this, addExplorationPaper, {
              data: subEntity
            })
            .then(res => {
              this.dialogMsg.dialogBookMagaz = false;
              this.getExplorationPapers();
            });
        }
      } else if (this.dialogMsg.activeName == "magazines") {
        subEntity.type = "magazines";
        if (this.dialogMsg.kind == "update") {
          this.$global
            .GraphqlMutation(this, updateExplorationPaper, {
              data: subEntity,
              id: addMsg.id
            })
            .then(res => {
              this.dialogMsg.dialogBookMagaz = false;
              this.getExplorationPapers();
            });
        } else {
          this.$global
            .GraphqlMutation(this, addExplorationPaper, {
              data: subEntity
            })
            .then(res => {
              this.dialogMsg.dialogBookMagaz = false;
              this.getExplorationPapers();
            });
        }
      }
    },
    // 新增关键词
    addKeyOK(addMsg) {
      // addMsg.tags = []
      this.explorationDetail.keywords.push({
        name: addMsg.name,
        englishName: addMsg.englishName,
        explorationId: parseFloat(this.$router.app._route.query.id)
      });
      let { status, keywords, tags } = this.explorationDetail;
      const subEntity = {
        status,
        keywords,
        tags
      };

      this.$global
        .GraphqlMutation(this, updateExploration, {
          data: subEntity,
          id: this.$router.app._route.query.id
        })
        .then(res => {
          this.dialogMsg.dialogKeyWorlds = false;
          this.getExploration();
        });
    },
    // 新增学者
    addScholarOK(person) {
      this.$global
        .GraphqlMutation(this, addExplorationPerson, {
          personId: person.personId,
          explorationId: this.$router.app._route.query.id
        })
        .then(res => {
          this.dialogMsg.dialogScholar = false;
          this.getExploration();
        });
    },
    // 新增文章
    addArticleOK(addMsg) {
      addMsg.type = "articles";
      addMsg.explorationId = this.$router.app._route.query.id;
      let {
        name,
        author,
        organizer,
        type,
        orderNum,
        intro,
        recommendReason,
        explorationId,
        tags
      } = addMsg;
      const subEntity = {
        name,
        author,
        organizer,
        intro,
        type,
        orderNum,
        explorationId,
        recommendReason,
        tags
      };
      subEntity.tags = [];
      if (this.dialogMsg.kind == "update") {
        this.$global
          .GraphqlMutation(this, updateExplorationPaper, {
            data: subEntity,
            id: addMsg.id
          })
          .then(res => {
            this.dialogMsg.dialogArticle = false;
            this.getExplorationPapers();
          });
      } else {
        this.$global
          .GraphqlMutation(this, addExplorationPaper, {
            data: subEntity
          })
          .then(res => {
            this.dialogMsg.dialogArticle = false;
            this.getExplorationPapers();
          });
      }
      this.dialogMsg.kind = "";
    },
    // 新增案例
    addCaseOK(addMsg) {
      addMsg.type = "cases";
      addMsg.explorationId = this.$router.app._route.query.id;
      addMsg.tags = [];
      // addMsg.organizer=
      let { name, author, type, explorationId, tags ,organizer} = addMsg;
      let image = addMsg.image;
      const subEntity = {
        name,
        author,
        type,
        explorationId,
        tags,
        organizer,
        image
      };
      if (this.dialogMsg.kind == "update") {
        this.$global
          .GraphqlMutation(this, updateExplorationPaper, {
            data: subEntity,
            id: addMsg.id
          })
          .then(res => {
            this.dialogMsg.dialogCase = false;
            this.getExplorationPapers();
          });
      } else {
        this.$global
          .GraphqlMutation(this, addExplorationPaper, {
            data: subEntity
          })
          .then(res => {
            this.dialogMsg.dialogCase = false;
            this.getExplorationPapers();
          });
      }
    },
    // 新增剩下四个模块
    addTabsOK(addMsg) {
      addMsg.type = this.dialogMsg.activeName;
      addMsg.explorationId = this.$router.app._route.query.id;
      addMsg.tags = [];
      let {
        name,
        englishName,
        image,
        source,
        type,
        explorationId,
        tags
      } = addMsg;
      const subEntity = {
        name,
        englishName,
        image,
        source,
        type,
        explorationId,
        tags
      };
      if (this.dialogMsg.kind == "update") {
        this.$global
          .GraphqlMutation(this, updateExplorationPaper, {
            data: subEntity,
            id: addMsg.id
          })
          .then(res => {
            this.dialogMsg.dialogTab = false;
            this.getExplorationPapers();
          });
      } else {
        this.$global
          .GraphqlMutation(this, addExplorationPaper, {
            data: subEntity
          })
          .then(res => {
            this.dialogMsg.dialogTab = false;
            this.getExplorationPapers();
          });
      }
      this.dialogMsg.kind = "";
    },
    // 修改 学者的弹窗
    updateScholar(item) {
      this.dialogItem = item;
      this.dialogMsg.kind = "update";
      this.dialogMsg.dialogScholar = true;
    },
    // 修改 杂志和书籍的弹窗
    updateBooksMag(item) {
      item.publishTime = item.createTime;
      this.dialogItem = item;
      this.dialogMsg.kind = "update";
      this.dialogMsg.dialogBookMagaz = true;
    },
    // 修改 文章的弹窗
    updateArtice(item) {
      this.dialogItem = item;
      this.dialogMsg.kind = "update";
      this.dialogMsg.dialogArticle = true;
    },
    updateCase(item) {
      this.dialogItem = item;
      this.dialogMsg.kind = "update";
      this.dialogMsg.dialogCase = true;
    },
    // 修改 剩下四个一样的样式
    updatePaper(item) {
      this.dialogItem = item;
      this.dialogMsg.kind = "update";
      this.dialogMsg.dialogTab = true;
    },
    // 删除关键字
    deleteKeyWorlds(id,item){
      this.dialogDeleteMsg.data.ids = [];
       this.dialogDeleteMsg.title = "keyworlds";
      this.dialogDeleteMsg.dialogDelete = true;
      this.dialogDeleteMsg.data.ids.push(id);
     
    },
    // 删除相关学者
    deleteScholar(id) {
      this.dialogDeleteMsg.data.ids = [];
      this.dialogDeleteMsg.dialogDelete = true;
      this.dialogDeleteMsg.data.ids.push(id);
      this.dialogDeleteMsg.title = "scholar";
    },
    //删除
    deletePaper(id) {
      this.dialogDeleteMsg.data.ids = [];
      this.dialogDeleteMsg.dialogDelete = true;
      this.dialogDeleteMsg.data.ids.push(id);
      this.dialogDeleteMsg.title = "paper";
    },
    isCancel() {
      this.deleteShow = false;
    },
    // tab页删除的取消按钮
    tabsCancel() {
      this.dialogDeleteMsg.dialogDelete = false;
    },
    // tab页学者删除的确定按钮
    tabsScholarDelete(deleteMsg) {
      this.$global
        .GraphqlMutation(this, deleteExplorationPersons, {
          data: deleteMsg.data,
          explorationId: this.$router.app._route.query.id
        })
        .then(res => {
          this.dialogDeleteMsg.dialogDelete = false;
          this.getScholar(this.explorationDetail.name);
        });
    },
    // tab页删除keyworlds
    tabsKeyWoldsDelete(deleteMsg){
      for(let i=0;this.tagPage.keywords.length>i;i++){
        if(this.tagPage.keywords[i].id==deleteMsg){
          this.tagPage.keywords.splice(i,1)
        }
      }
       this.dialogDeleteMsg.dialogDelete = false;
     this.saveArea()
    },
    // tab页paper接口删除的确定按钮
    ispaperDelete(deleteMsg) {
      this.$global
        .GraphqlMutation(this, deleteExplorationPapers, {
          data: deleteMsg.data
        })
        .then(res => {
          this.dialogDeleteMsg.dialogDelete = false;
          this.getExplorationPapers();
        });
    },
    isDelete(id) {
      this.$global
        .GraphqlMutation(this, deletePracticeAward, {
          id: id
        })
        .then(res => {
          this.getPracticeAwards();
        });
      this.deleteShow = false;
    },

    // 点击编辑
    edit() {
      this.managerState = (this.managerState == false) == true ? true : false;
      // this.editExploration =dialogDeleteMsg
      this.editExploration =
        (this.editExploration == false) == true ? true : false;
    },
    // 新增bp
    addExploration() {
      let {
        name,
        englishName,
        createTime,
        updateTime,
        bgImage,
        bgSmallImage,
        author,
        authorImage,
        authorEnglishName,
        authorTitle,
        authorUniversity,
        coverImage,

        tags,
        keywords,
        status
      } = this.explorationDetail;
      const subEntity = {
        name,
        englishName,
        createTime,
        updateTime,
        bgImage,
        bgSmallImage,
        authorImage,
        author,
        authorEnglishName,
        authorTitle,
        authorUniversity,
        coverImage,
        tags,
        keywords,
        status
      };
      this.$global
        .GraphqlMutation(this, addExploration, {
          // Parameters
          data: this.$global.checkNull(subEntity)
        })
        .then(res => {
          this.bpType = "update";
          this.explorationDetail.id = res.data[0].id;
          this.$router.push({
            path: "/admin/explorationdetail",
            query: { id: res.data[0].id },
            name: "explorationdetail",
            params: res.data[0]
          });
          this.getExploration();
        });
    },
    // 修改 编辑 看看是否是空数据
    saveArea() {
      this.explorationDetail.name = this.$global.trimStr(
        this.explorationDetail.name
      );
      this.explorationDetail.englishName = this.$global.trimStr(
        this.explorationDetail.englishName
      );
      let {
        name,
        englishName,
        createTime,
        updateTime,
        bgImage,
        bgSmallImage,
        authorImage,
        authorEnglishName,
        authorTitle,
        authorUniversity,
        coverImage,
        keywords,
        author,
        tags,
        status
      } = this.explorationDetail;
      const subEntity = {
        name,
        englishName,
        createTime,
        updateTime,
        bgImage,
        bgSmallImage,
        authorImage,
        author,
        authorEnglishName,
        authorTitle,
        authorUniversity,
        tags,
        coverImage,
        keywords,
        status
      };
      this.$global
        .GraphqlMutation(this, updateExploration, {
          // Parameters
          id: this.$router.app._route.query.id,
          data: this.$global.checkNull(subEntity)
        })
        .then(res => {
          this.loading = false;
          this.$global.success(this, "操作成功");
          this.getExploration();
        });
    }
  }
};
</script>
<style lang="scss" scoped>
dl {
  margin: 0;
  margin-top: 50px;
}
.pc-explorationDetail {
  // 头部面包屑以及功能部分
    .pc-exploration-button {
    display: flex;
    justify-content: center;
    align-items: center;
    h4 {
      // margin-top: -10px;
      align-self: center;
      font-size: 16px;
      background: $pageViewSmall;
      padding: 10px 29px 14px;
      font-weight: 400;
      color: $base-color;
      font-family: $english;
      border-radius: 4px;
      cursor: pointer;
      margin-left: 20px;
      margin-top: 40px;
    }
    h4:first-of-type {
      background: rgba(84, 112, 198, 0.14);
      color: $pageViewSmall;
      margin-right: 30px;
    }
    // h4:last-of-type{

    // }
  }
  .pc-explorationDetail-head {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid $border-color;
    margin-top: 30px;
    padding-bottom: 15px;
    .pc-explorationDetail-head-bread {
      display: flex;
      h2 {
        align-self: flex-end;
        font-size: 18px;
        margin-right: 40px;
      }
      .pc-breadcrumb {
        margin-top: 26px;
      }
    }
    h4 {
      align-self: flex-end;
      font-size: 16px;
      background: $pageViewSmall;
      padding: 10px 29px 14px;
      font-weight: 400;
      color: $base-color;
      font-family: $english;
      border-radius: 4px;
      cursor: pointer;
    }
  }
  // 前沿基本信息
  .pc-explorationDetail-information {
    box-shadow: $boxshadow;
    padding: 35px 30px 0px;
    margin-top: 40px;
    > h2 {
      border-bottom: 1px solid $border-color;
      font-size: 20px;
      padding-bottom: 15px;
      color: $mainTitle;
    }
    // 基本信息的内容框
    .pc-explorationDetail-information-contain {
      // border: 1px solid red;
      padding-top: 34px;
      padding-bottom: 10px;
      display: flex;
      justify-content: space-between;
      .contain-img {
        flex-direction: row !important;
      }
      .pc-explorationDetail-information-contain-img {
        display: flex;
        flex-direction: column;
        margin-right: 40px;
        .process {
            padding-top:20px;
            width:100%;
            vertical-align:center;
            text-align:center;
            height:140px;
            width: 249px;
        }
        /deep/ .logoImg {
          .el-upload--picture-card {
            width: 249px;
            height: 140px;
            line-height: 160px;
            img {
              width: 249px;
              height: 140px;
              object-fit: contain;
            }
          }
        }
        .logo-Img {
          width: 249px;
          height: 140px;
          display: flex;
          margin-right: 40px;
          img {
            width: 249px;
            height: 140px;
            // height: 100%;
            object-fit: contain;
          }
        }
      }
      // 院校简介内容部分
      .pc-explorationDetail-information-contain-word {
        display: flex;
        flex-wrap: wrap;
        width: 65%;
        // justify-content: flex-end;
        li {
          display: flex;
          font-size: 16px;
          color: $mainTitle;
          font-family: $english;
          width: 100%;
          margin-bottom: 35px;
          h4 {
            width: 100px;
            min-width: 100px;
            text-align: right;
            margin-right: 20px;
            font-weight: 400;
            align-self: center;
          }
          .el-form {
            display: flex;
            .el-select {
              margin-right: 20px;
            }
          }
          span {
            font-weight: 600;
            word-break: normal;
            width: auto;
            display: block;
            // white-space: pre-wrap;
            word-wrap: break-word;
            overflow: hidden;
            align-self: flex-start;
          }
        }
        li:nth-of-type(3) {
          width: 50%;
        }
        li:nth-of-type(4) {
          width: 50%;
        }
        .area-li {
          .area-li-div {
            display: flex;
            span {
              margin-right: 20px;
            }
          }
        }
      }
      // 院校简介内容底部的简介部分
      .pc-explorationDetail-information-contain-intro {
        /deep/ .el-textarea__inner {
          resize: none !important;
        }
      }
    }
  }
  // 作者信息
  .pc-explorationDetail-article {
    box-shadow: $boxshadow;
    padding: 35px 30px 50px;
    margin-top: 40px;
    /deep/ .el-upload--picture-card {
      width: 350px;
      height: 250px;
      line-height: 16;
    }
    > h2 {
      border-bottom: 1px solid $border-color;
      font-size: 20px;
      padding-bottom: 15px;
      color: $mainTitle;
    }
    .pc-explorationDetail-article-contain {
      display: flex;
      justify-content: space-between;
      margin-top: 30px;
      .pc-explorationDetail-article-logo {
        margin-right: 150px;
        .process {
          text-align: center;
          width:258px;
          height:237px;
          padding-top:50px;
        }
        .logo-Img {
          width: 258px;
          height: 237px;
          display: flex;
          margin-right: 40px;
          img {
            // height: 240px;
            // height: 100%;
            width: 100%;
             height: 237px;
            object-fit: contain;
          }
        }
      }
      ul {
        display: block;
        flex-wrap: wrap;
        width: 76%;
        // justify-content: flex-end;
        li {
          width: 100%;
          height: 40px;
          display: flex;
          font-size: 16px;
          color: $mainTitle;
          font-family: $english;
          margin-bottom: 15px;
          h4 {
            width: 100px;
            min-width: 100px;
            text-align: right;
            margin-right: 20px;
            font-weight: 400;
            align-self: center;
          }
          .el-input{
            width: 213px;
          }
          .choose {
            display: flex;
            justify-content: flex-end;
            span {
              color: red;
              margin-left: 3px;
              margin-top: 2px;
              align-self: center;
              // line-height: 2;
            }
          }
          .el-form {
            display: flex;
            .el-select {
              margin-right: 20px;
            }
          }
          span {
            font-weight: 600;
            word-break: normal;
            width: auto;
            display: block;
            word-wrap: break-word;
            overflow: hidden;
            align-self: center;
          }
        }
        .area-li {
          .area-li-div {
            display: flex;
            span {
              margin-right: 20px;
            }
          }
        }
      }
    }
  }
  // 大学院校标签
  .pc-explorationDetail-tags {
    box-shadow: $boxshadow;
    padding: 35px 30px 20px;
    margin-top: 40px;
    > h2 {
      border-bottom: 2px solid $border-color;
      font-size: 20px;
      padding-bottom: 15px;
      color: $mainTitle;
    }
    ul {
      display: flex;
      flex-wrap: wrap;
      margin-top: 40px;
      li {
        min-width: 70px;
        text-align: center;
        padding: 11px 21px;
        border: 1px solid $universityBorder;
        background: $universityBackground;
        margin-right: 20px;
        margin-bottom: 20px;
        color: $timeBtn;
        font-size: 14px;
        font-family: $english;
        border-radius: 4px;
        .el-icon-close {
          margin-left: 5px;
        }
      }
      li:last-child {
        border: 1px dashed $timeBtn;
        background: none;
        cursor: pointer;
      }
      .managerClass {
        transition: transform 0.3s;
      }
      .managerClass:hover {
        transform: translateY(-10px);
        cursor: pointer;
      }
    }
  }
  //   院校详情
  .pc-explorationDetail-detail {
    box-shadow: $boxshadow;
    padding: 25px 30px 50px;
    margin-top: 40px;
    
    .el-tabs {
      .el-tabs__content {
        .el-tab-pane {
          .addTitle {
            margin-top: 15px;
            cursor: pointer;
            .el-icon-circle-plus-outline {
              font-size: 18px;
              color: $blueBtna;
            }
            span {
              font-size: 14px;
              text-align: center;
              color: $blueBtna;
            }
          }
        }
        // 标签表格 关键词
        .tabs-keywords {
          margin-top:34px;
          display: flex;
          flex-wrap: wrap;
          flex-direction: column;
          .tabs-keywords-contain {
            display: flex;
            flex-wrap: wrap;
            .choice-keywords{
                margin: 0;
                 margin-right: 100px;
              position: relative;
              padding-bottom: 30px;
              margin-top: 40px;
              .el-icon-error {
                position: absolute;
                right: -44px;
                font-size: 24px;
                color: $deleteIcon;
              }
            }
            dl {
              margin: 0;
              margin-bottom: 30px;
              display: flex;
              margin-right: 100px;
              // margin-right: 80px;
              dd {
                margin: 0;
                margin-right: 30px;
                width: 70px;
                // margin-right: 45px;
                color: $keywords;
                font-size: 16px;
              }
              dt {
                display: flex;
                flex-direction: column;
                .keywordsInput {
                  margin-bottom: 30px;
                }
                span {
                  color: $keywordsCE;
                  font-size: 14px;
                }
              }
            }
          }
        }
        // 标签表格 学者
        .tabs-scholars {
          margin-top:34px;
          display: flex;
          flex-wrap: wrap;
          flex-direction: column;
          
          .tabs-scholars-contain {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            .choice-scholar {
              position: relative;
              border: 1px solid $keywords;
              border-radius: 4px;
              transition: transform 0.3s;
              cursor: pointer;
            }
            .choice-scholar:hover {
              transform: translateY(-25px);
            }
            dl {
              padding:10px 5px;
              margin: 0;
              width: 210px;
              display: flex;
              margin-right: 40px;
              margin-bottom: 30px;
              .el-icon-close:before {
                box-shadow: $iconshadow;
                border-radius: 15px;
                padding: 3px;
                color: $keywords;
                background: $base-color;
              }
              .el-icon-close {
                position: absolute;
                right: -5px;
                top: -3px;
                z-index: 99;
              }
              dd {
                margin: 0;
                margin-right: 40px;
                color: $keywords;
                font-size: 16px;
                img {
                  border-radius: 100px;
                  width: 60px;
                  height: 60px;
                }
              }
              dt {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-self: center;
                h4 {
                  font-size: 16px;
                }
                span {
                  color: $timeWorld;
                  font-size: 14px;
                }
              }
            }
          }
        }
        // 标签表格 书籍
        .tabs-books {
          margin-top:34px;
          display: flex;
          flex-wrap: wrap;
          flex-direction: column;
          .tabs-books-contain {
            display: flex;
            flex-wrap: wrap;
            flex-direction: column;
            .choice-book {
              position: relative;
              border-bottom: 1px solid $schoolTagBorder;
              padding-bottom: 30px;
              margin-top: 30px;
              margin-bottom: 0;
              .el-icon-error {
                position: absolute;
                right: 0;
                font-size: 24px;
                color: $deleteIcon;
              }
              .el-icon-edit {
                position: absolute;
                right: 50px;
                margin-left: 25px;
                z-index: 99;

                font-size: 24px;
                color: $blueBtna;
              }
              .el-icon-edit:before {
                border-radius: 15px;
                background: $base-color;
              }
            }
            dl {
              margin: 0;
              display: flex;
              margin-bottom: 35px;

              dd {
                margin: 0;
                margin-right: 45px;
                color: $keywords;
                font-size: 16px;
                width: 125px;
                height: 180px;
                img {
                  width: 125px;
                  height: 180px;
                  object-fit: contain;
                }
              }
              dt {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                > div {
                  h5 {
                    padding: 7px 0;
                    font-size: 16px;
                  }
                  h6 {
                    padding: 8px 0;
                    font-size: 14px;
                    font-weight: 400;
                  }
                }
                span {
                  // color: $keywordsCE;
                  font-size: 14px;
                }
              }
            }
          }
        }
        // 标签表格
        // 标签表格 文章
        .tabs-articles {
          margin-top:34px;
          display: flex;

          flex-direction: column;
          .tabs-articles-contain {
            display: flex;
            flex-direction: column;
            .choice-articles {
                 margin: 0;
              position: relative;
              border-bottom: 1px solid $schoolTagBorder;
              padding-bottom: 30px;
              margin-top: 40px;
           
              // margin-top: 30px;
              .el-icon-error {
                position: absolute;
                right: 0;
                font-size: 24px;
                color: $deleteIcon;
              }
              .el-icon-edit {
                position: absolute;
                right: 50px;
                margin-left: 25px;
                z-index: 99;
                font-size: 24px;
                color: $blueBtna;
              }
              .el-icon-edit:before {
                border-radius: 15px;
                background: $base-color;
              }
            }
            dl:nth-of-type(1) {
              margin-top: 0;
            }
            dl {
              margin: 0;
              display: flex;
              margin-top: 40px;
              margin-right: 100px;
              dd {
                margin: 0;
                margin-right: 10px;
                color: $keywords;
                font-size: 16px;
                i {
                  color: $thirdTitle;
                }
              }
              dt {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-self: center;
                > div {
                  h5 {
                    // padding: 7px 0;
                    padding-bottom: 16px;
                    font-size: 14px;
                    font-weight: 600;
                  }
                  h6 {
                    padding-bottom: 16px;
                    font-size: 14px;
                    font-weight: 400;
                  }
                }
                span {
                  padding-bottom: 16px;
                  font-size: 12px;
                }
              }
            }
          }
        }
        // 标签表格 案例
        .tabs-cases {
          margin-top:34px;
          display: flex;
          flex-wrap: wrap;
          flex-direction: column;

          .tabs-cases-contain {
            display: flex;
            flex-wrap: wrap;
            flex-direction: column;

            .choice-cases {
              position: relative;
              border-radius: 4px;
              .el-icon-error {
                // position: absolute;
                // right: 5px;
                margin-left: 20px;
                z-index: 99;
                font-size: 24px;
                color: $deleteIcon;
              }
              .el-icon-error:before {
                border-radius: 15px;
                background: $base-color;
              }
              .el-icon-edit {
                margin-left: 25px;
                z-index: 99;
                font-size: 24px;
                color: $blueBtna;
              }
              .el-icon-edit:before {
                border-radius: 15px;
                background: $base-color;
              }
            }
            dl:nth-of-type(1){
              margin-top: 0;
            }
            dl {
              margin: 0;
              margin-top: 30px;
              width: 100%;
              display: flex;
              margin-right: 20px;

              dd {
                margin: 0;
                margin-right: 40px;
                color: $keywords;
                font-size: 16px;
                img {
                  border-radius: 100px;
                  width: 60px;
                  height: 60px;
                }
              }
              dt {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-self: center;
                h4 {
                  font-size: 16px;
                  margin-bottom: 15px;
                }
                span {
                  // color: $timeWorld;
                  font-size: 14px;
                }
              }
            }
          }
        }
        // 标签表格 会议
        .tabs-conferences {
          margin-top:34px;
          display: flex;
          flex-wrap: wrap;
          flex-direction: column;

          .tabs-conferences-contain {
            display: flex;
            flex-wrap: wrap;
            flex-direction: column;

            .choice-conferences {
              position: relative;
              border-radius: 4px;
              .el-icon-error {
                // position: absolute;
                // right: 5px;
                margin-left: 20px;
                z-index: 99;
                font-size: 24px;
                color: $deleteIcon;
              }
              .el-icon-error:before {
                border-radius: 15px;
                background: $base-color;
              }
              .el-icon-edit {
                margin-left: 25px;
                z-index: 99;
                font-size: 24px;
                color: $blueBtna;
              }
              .el-icon-edit:before {
                border-radius: 15px;
                background: $base-color;
              }
            }
            dl:nth-of-type(1){
              margin-top: 0;
            }
            dl {
              margin: 0;
              margin-top: 30px;
              width: 100%;
              display: flex;
              margin-right: 25px;

              dd {
                width: 60px;
                  height: 60px;
                margin: 0;
                margin-right: 40px;
                color: $keywords;
                font-size: 16px;

                img {
                  border-radius: 100px;
                  width: 60px;
                  height: 60px;
                  object-fit: cover;
                }
              }
              dt {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                h4 {
                  font-size: 16px;
                }
                span {
                  color: $timeWorld;
                  font-size: 14px;
                }
              }
            }
          }
        }
        // 标签表格 组织
        .tabs-organizations {
          margin-top:34px;
          .tabs-organizations-contain {
          }
        }
      }
    }
    .detai-world {
      margin-top: 20px;
    }
  }
}
.el-input {
  .el-input__inner {
    border-color: #dcdfe6 !important;
  }
}

/deep/ .el-tabs__item {
  font-size: 16px;
}
/deep/ .el-tabs__item.is-active {
  color: $blueBtna;
}
/deep/ .el-tabs__active-bar {
  background-color: $blueBtna;
}

// /deep/ .el-tabs__header {
//   margin-bottom: 40px;
// }
</style>



// WEBPACK FOOTER //
// src/components/admin/exploration/ExplorationDetail.vue